import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const administrativeServices = [
  {
    serviceId: 'ADMIN_001',
    serviceName: 'Medical Certificate',
    category: 'Administrative Services',
    specialty: null,
    subCategory: 'Medical Certificates',
    description: 'Medical certificate for sick leave or fitness for work',
    cost: 120,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'ADMIN_MEDCERT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['medical certificate', 'sick leave', 'documentation'],
    displayOrder: 1
  },
  {
    serviceId: 'ADMIN_002',
    serviceName: 'Medical Report',
    category: 'Administrative Services',
    specialty: null,
    subCategory: 'Medical Reports',
    description: 'Detailed medical report for insurance or legal purposes',
    cost: 250,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'ADMIN_REPORT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['medical report', 'insurance', 'legal'],
    displayOrder: 2
  },
  {
    serviceId: 'ADMIN_003',
    serviceName: 'Prescription Renewal',
    category: 'Administrative Services',
    specialty: null,
    subCategory: 'Prescriptions',
    description: 'Renewal of chronic medication prescriptions',
    cost: 100,
    durationMinutes: 10,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'ADMIN_SCRIPT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['prescription', 'renewal', 'chronic medication'],
    displayOrder: 3
  },
  {
    serviceId: 'ADMIN_004',
    serviceName: 'Referral Letter',
    category: 'Administrative Services',
    specialty: null,
    subCategory: 'Referrals',
    description: 'Medical referral letter to specialists or other healthcare providers',
    cost: 80,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'ADMIN_REFERRAL',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['referral', 'specialist', 'letter'],
    displayOrder: 4
  },
  {
    serviceId: 'ADMIN_005',
    serviceName: 'Fitness Certificate',
    category: 'Administrative Services',
    specialty: null,
    subCategory: 'Fitness Certificates',
    description: 'Medical fitness certificate for sports, work, or travel',
    cost: 150,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'ADMIN_FITNESS',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['fitness certificate', 'sports', 'travel'],
    displayOrder: 5
  },
  {
    serviceId: 'ADMIN_006',
    serviceName: 'Medical Record Request',
    category: 'Administrative Services',
    specialty: null,
    subCategory: 'Medical Records',
    description: 'Processing and provision of medical records',
    cost: 50,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.ADMINISTRATOR,
    status: 'active',
    billingCode: 'ADMIN_RECORDS',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['medical records', 'documentation', 'request'],
    displayOrder: 6
  }
]

export default administrativeServices
